// import Vue from 'vue'
/* eslint-disable */
import { createWebHistory, createRouter } from "vue-router";
import { trackRouter } from "vue-gtag-next";
import { useAuthStore, useRequirementsStore } from "@/stores";
import { mainServices } from "@/services/mainServices";

// import HomePage from '@/pages/HomePage';
import InsuranceNavigatorPage from "@/pages/InsuranceNavigatorPage";
import ReviewAndSendToPlanPage from "@/pages/ReviewAndSendToPlanPage";
// import SignUp from '@/pages/SignUp';
import CompleteRegistration from "@/pages/CompleteRegistration";
import SignIn from "@/pages/SignIn";
import PasswordResetRequest from "@/pages/PasswordResetRequest";
import PasswordReset from "@/pages/PasswordReset";
import ConfirmEmail from "@/pages/ConfirmEmail";
import ReviewInitiatedPriorAuthPage from "@/pages/ReviewInitiatedPriorAuthPage";
import HealthCheckView from "@/pages/HealthCheckView.vue";
import PatientIntakeReview from "./pages/PatientIntakeReview.vue";
import PatientIntakeQualifyPatient from "./pages/PatientIntakeQualifyPatient.vue";
import PatientIntakeClinicalReview from "./pages/PatientIntakeClinicalReview.vue";
import IntakeOpsReview from "./pages/IntakeOpsReview.vue";
import OpsUtilities from "./pages/OpsUtilities.vue";
import CreateSubmissionView from "@/pages/CreateSubmissionView.vue";
import HealthMonitoring from "@/pages/HealthMonitoring.vue";
import ImportCMMSubmissionPage from "@/pages/ImportCMMSubmissionPage.vue";
import QuickStartClinicalReviewPage from "@/pages/QuickStartClinicalReviewPage.vue";
import PromptFeedbackTriage from "@/pages/PromptFeedbackTriage.vue";
import PromptTuningQueue from "@/pages/PromptTuningQueue.vue";
import PromptTuningDetail from "@/pages/PromptTuningDetail.vue";
import AcceptInvite from "@/pages/AcceptInvite.vue";
import UserManagement from "@/pages/UserManagement.vue";
import DelegateAgreements from "@/pages/DelegateAgreements.vue";

const publicAccessRoutes = [
  // {
  //   path: "/register",
  //   name: "register",
  //   component: SignUp,
  //   title: "Do Prior Auth",
  // },
  {
    path: "/complete-registration/:user_id?/:token?",
    name: "complete-registration",
    component: CompleteRegistration,
    title: "Do Prior Auth",
  },
  {
    path: "/login",
    name: "login",
    component: SignIn,
    title: "Do Prior Auth",
  },
  {
    path: "/password-reset-request",
    name: "password-reset-request",
    component: PasswordResetRequest,
    title: "Password Reset",
  },
  {
    path: "/confirm-email/:user_id/:token",
    name: "confirmEmail",
    component: ConfirmEmail,
    title: "Do Prior Auth",
  },
  {
    path: "/password-reset/:token?",
    name: "password-reset",
    component: PasswordReset,
    title: "Password Reset",
  },
  {
    path: "/health-check",
    name: "health-check",
    component: HealthCheckView,
    title: "Health Check",
  },
  {
    path: "/accept-invite/:uidb64?/:token?",
    name: "accept-invite",
    component: AcceptInvite,
    title: "Create Your Account",
  },
];

const protectedRoutes = [
  {
    path: "/",
    name: "home",
    component: () => import("@/pages/PATablePage.vue"),
    title: "Prior Auth",
  },
  {
    path: "/reported-issues",
    name: "reported-issues",
    component: () => import("@/pages/ReportedIssuesPage.vue"),
    title: "Reported Issues",
  },
  {
    path: "/check-my-coverage/:id?",
    name: "check-my-coverage",
    component: ReviewAndSendToPlanPage,
    title: "Insurance Criteria",
  },
  {
    path: "/access-initiated-prior-auth/:id",
    name: "access-initiated-prior-auth",
    component: ReviewInitiatedPriorAuthPage,
    title: "Access Initiated Prior Authorization",
  },
  {
    path: "/all-submissions",
    name: "all-submissions",
    redirect: "/prior-auth",
  },
  {
    path: "/create-submission/:id?",
    name: "create-submission",
    component: CreateSubmissionView,
    title: "Create Submission",
  },
  {
    path: "/all-patients",
    name: "all-patients",
    redirect: "/intake",
  },
  {
    path: "/intake-review/:id",
    name: "intake-review",
    component: PatientIntakeReview,
    title: "Intake Review",
  },
  {
    path: "/intake/order/:id/qualify",
    name: "qualify-order",
    component: PatientIntakeQualifyPatient,
    title: "Benefit Verification",
  },
  {
    path: "/intake/order/:id/document-review",
    name: "document-review-order",
    component: PatientIntakeClinicalReview,
    title: "Medical Necessity",
  },
  {
    // Deprecated: appeals now live on the check-my-coverage page. Redirect forward-only so stale links work.
    path: "/order/:id/denial-follow-up",
    name: "denial-follow-up-order",
    redirect: (to) => ({ name: "check-my-coverage", params: { id: to.params.id }, query: { section: "appeal" } }),
  },
  {
    path: "/ops-review/intake-document/:key",
    name: "ops-review-intake-document",
    component: IntakeOpsReview,
    title: "Intake Ops Review",
  },
  {
    path: "/ops-utilities",
    name: "ops-utilities",
    component: OpsUtilities,
    title: "Ops Utilities",
  },
  {
    path: "/ops-utilities/historical-analysis/:id",
    name: "historical-analysis-run",
    component: () => import("@/pages/HistoricalAnalysisRunDetail.vue"),
    title: "Historical Analysis Run",
  },
  {
    path: "/monitoring",
    name: "monitoring",
    component: HealthMonitoring,
    title: "API Monitoring",
  },
  {
    path: "/ops/policy-review-lab",
    name: "policy-review-lab",
    component: () => import("@/pages/PolicyReviewLab.vue"),
    title: "Policy Review Lab",
  },
  {
    path: "/ops/policy-review-lab/corrections",
    name: "policy-review-corrections",
    component: () => import("@/pages/PolicyReviewCorrections.vue"),
    title: "Pharmacist Corrections",
  },
  {
    path: "/ops/policy-review-lab/runs/:id",
    name: "policy-review-lab-run",
    component: () => import("@/pages/PolicyReviewLabRunDetail.vue"),
    title: "Policy Review Lab Run",
  },
  {
    path: "/ops/classification-lab",
    name: "classification-lab",
    component: () => import("@/pages/ClassificationLab.vue"),
    title: "Classification Lab",
  },
  {
    path: "/ops/classification-lab/runs/:id",
    name: "classification-lab-run",
    component: () => import("@/pages/ClassificationLabRunDetail.vue"),
    title: "Classification Lab Run",
  },
  {
    path: "/ops/prompt-tuning/triage",
    name: "prompt-tuning-triage",
    component: PromptFeedbackTriage,
    title: "Feedback Triage",
  },
  {
    path: "/ops/prompt-tuning",
    name: "prompt-tuning-queue",
    component: PromptTuningQueue,
    title: "Prompt Proposals",
  },
  {
    path: "/ops/prompt-tuning/:id",
    name: "prompt-tuning-detail",
    component: PromptTuningDetail,
    title: "Prompt Proposal",
  },
  {
    path: "/ops/agent-runs",
    name: "agent-runs",
    component: () => import("@/pages/AgentRuns.vue"),
    title: "Agent Runs",
  },
  {
    path: "/ops/agent-runs/:id",
    name: "agent-run",
    component: () => import("@/pages/AgentRunDetail.vue"),
    title: "Agent Run",
  },
  {
    path: "/import-cmm-submission",
    name: "import-cmm-submission",
    component: ImportCMMSubmissionPage,
    title: "Import CMM Submission",
  },
  {
    path: "/quick-start-clinical-review",
    name: "quick-start-clinical-review",
    component: QuickStartClinicalReviewPage,
    title: "Quick Start Medical Necessity",
  },
  {
    path: "/voice-ai",
    name: "voice-ai",
    component: () => import("@/pages/VoiceAI.vue"),
    title: "Voice AI",
  },
  {
    path: "/intake",
    name: "intake",
    component: () => import("@/pages/IntakeTablePage.vue"),
    title: "Intake",
  },
  {
    path: "/prior-auth",
    name: "prior-auth",
    component: () => import("@/pages/PATablePage.vue"),
    title: "Prior Auth",
  },
  {
    path: "/inbox",
    name: "inbox",
    component: () => import("@/pages/InboxPage.vue"),
    title: "Inbox",
  },
  {
    path: "/user-management",
    name: "user-management",
    component: UserManagement,
    title: "User Management",
  },
  {
    path: "/analysis/denials",
    name: "analysis-denials",
    component: () => import("@/pages/InsightsView.vue"),
    title: "Denial Insights",
  },
  {
    path: "/providers",
    name: "providers-management",
    component: () => import("@/pages/ProvidersManagementPage.vue"),
    title: "Providers Management",
  },
  {
    path: "/providers/:npi",
    name: "provider-scorecard",
    component: () => import("@/pages/ProviderScorecardView.vue"),
    title: "Provider Scorecard",
  },
  // Keeps links from the short-lived Analysis grouping alive.
  {
    path: "/analysis/providers",
    redirect: { name: "providers-management" },
  },
  {
    path: "/analysis/providers/:npi",
    redirect: (to) => ({ name: "provider-scorecard", params: { npi: to.params.npi } }),
  },
  // Keeps links and bookmarks from the single-page Insights era alive.
  {
    path: "/insights",
    name: "insights",
    redirect: { name: "analysis-denials" },
    title: "Denial Insights",
  },
  {
    path: "/delegate-agreements",
    name: "delegate-agreements",
    component: DelegateAgreements,
    title: "Delegate Agreements",
  },
  {
    path: "/video-library",
    name: "video-library",
    component: () => import("@/pages/FeatureVideoLibrary.vue"),
    title: "Tutorials",
  },
  {
    path: "/status-legend",
    name: "status-legend",
    component: () => import("@/pages/StatusLegendPage.vue"),
    title: "PA Status Legend",
  },
  {
    path: "/billing",
    name: "billing",
    component: () => import("@/pages/BillingPage.vue"),
    title: "Billing",
  },
  {
    path: "/carequality-settings",
    name: "carequality-settings",
    component: () => import("@/pages/CarequalitySettingsPage.vue"),
    title: "Carequality",
    beforeEnter: async () => {
      const requirementsStore = useRequirementsStore();
      if (!requirementsStore.clientConfig) await requirementsStore.refreshCurrentUserClientConfig();
      if (requirementsStore.clientConfig?.intake?.carequalityEnabled) return true;
      return { name: "prior-auth" };
    },
  },
];

// Demo mode is available in every environment (it's a sales/prospect feature).
// DemoWrapper snapshots & restores any real session so visiting /demo never logs
// a real user out, runs against a fake user with no staff/admin flags, and is
// marked noindex so crawlers skip it.
const demoRoutes = [
  {
    path: "/demo",
    component: () => import("@/demo/DemoWrapper.vue"),
    children: [
      { path: "", redirect: "/demo/prior-auth" },
      {
        path: "intake",
        name: "demo-intake",
        component: () => import("@/pages/IntakeTablePage.vue"),
        meta: { title: "Demo — Intake" },
      },
      {
        path: "prior-auth",
        name: "demo-prior-auth",
        component: () => import("@/pages/PATablePage.vue"),
        meta: { title: "Demo — Prior Auth" },
      },
      {
        path: "import-cmm-submission",
        name: "demo-import-cmm-submission",
        component: ImportCMMSubmissionPage,
        meta: { title: "Demo — Import CMM" },
      },
      // Detail pages are not available in demo — clicking a row stays on the dashboard
      { path: "check-my-coverage/:id?", name: "demo-check-my-coverage", redirect: "/demo/prior-auth" },
    ],
  },
];

for (const r of publicAccessRoutes) {
  r.meta = { title: r.title || "Do Prior Auth" };
}

for (const r of protectedRoutes) {
  r.meta = { loginRequired: true, title: r.title || "Do Prior Auth" };
}

const router = createRouter({
  history: createWebHistory(),
  linkActiveClass: "active",
  routes: [...demoRoutes, ...publicAccessRoutes, ...protectedRoutes],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    // Same-path navigations are query/hash syncs (list-page filters via router.replace) — keep position.
    if (to.path === from.path) {
      return false;
    }
    return { top: 0 };
  },
});

// Routes hidden from the nav when the org's config disables them. Direct URLs redirect to
// prior-auth instead of rendering a page the org doesn't use. Fallbacks mirror the nav buttons:
// intake defaults visible (missing flag = enabled), import-cmm defaults hidden.
// A demographics-reimport jump (?key=... from the order detail banner) bypasses the import-cmm
// gate: reimport eligibility is per-submission (CMM submission type), not per-org shortcut flag.
const CONFIG_GATED_ROUTES = {
  intake: (config) => config?.intake?.intakeEnabled ?? true,
  "import-cmm-submission": (config, to) =>
    Boolean(to.query.key) || (config?.priorAuth?.cmmIntakeEnabled ?? false),
};

async function configGateRedirect(to) {
  const gate = CONFIG_GATED_ROUTES[to.name];
  if (!gate) return null;
  const requirementsStore = useRequirementsStore();
  // Refetch when the slot is empty OR holds a viewed company's config (intake review pages load
  // the order's company into the shared slot) — never gate the user's own navigation on it.
  if (!requirementsStore.clientConfig || !requirementsStore.clientConfigIsActiveCompany) {
    try {
      await requirementsStore.refreshCurrentUserClientConfig();
    } catch {
      // Config fetch failed (e.g. expired session mid-refresh) — gate on defaults below.
    }
  }
  // Re-check provenance at decision time: a concurrent viewed-company refresh can supersede the
  // guard's own fetch (request sequence token), leaving another org's config in the slot. In that
  // case gate on defaults (null) rather than the wrong tenant's flags.
  const config = requirementsStore.clientConfigIsActiveCompany ? requirementsStore.clientConfig : null;
  return gate(config, to) ? null : { name: "prior-auth" };
}

router.beforeEach(async (to, from) => {
  const authManager = useAuthStore();
  document.title = to.meta.title || "Do Prior Auth";

  // Demo mode: redirect non-demo routes to their demo equivalents
  if (from.path.startsWith("/demo") && !to.path.startsWith("/demo") && to.name) {
    const demoName = `demo-${to.name}`;
    if (router.hasRoute(demoName)) {
      return { name: demoName, params: to.params, query: to.query };
    }
  }

  if (!authManager.loggedIn && to.meta.loginRequired) {
    return { name: "login", query: { redirect: to.fullPath } };
  }
  // Provider logins (LAM-5263) have exactly one page: the read-only PA grid. They carry no company, so
  // the client-config lookup below (and every other page) has nothing to serve them.
  const providerRoutes = ["prior-auth", "check-my-coverage", "video-library", "status-legend"];
  if (to.meta.loginRequired && authManager.userInfo?.isProvider && !providerRoutes.includes(to.name)) {
    return { name: "prior-auth" };
  }
  if (authManager.loggedIn) {
    const gateRedirect = await configGateRedirect(to);
    if (gateRedirect) return gateRedirect;
  }
  if (to.name === "home" && authManager.loggedIn) {
    try {
      const config = await mainServices.getCurrentUserClientConfig();
      const page = config?.uiConfig?.defaultPostLoginPage || "prior-auth";
      if (page === "home" || !router.hasRoute(page)) {
        return { name: "prior-auth" };
      }
      return { name: page };
    } catch {
      // API call failed — likely an expired session. The axios interceptor
      // will have already attempted a token refresh and redirected to login
      // if the refresh also failed. If we reach here the user is being
      // sent to login, so we just guard against rendering the wrong page.
      if (!authManager.loggedIn) {
        return { name: "login", query: { redirect: to.fullPath } };
      }
      return { name: "prior-auth" };
    }
  }
});

trackRouter(router);

export default router;
